module.exports = __webpack_public_path__ + "static/media/cov-19-pass.f80ce384.png";